import { TFunction } from 'i18next';

export const errorMessage = (t: TFunction) => ({
  firstNameRequired: t('commonError.firstNameRequired'),
  firstNameInvalid: t('commonError.firstNameInvalid'),
  lastNameRequired: t('commonError.lastNameRequired'),
  lastNameInvalid: t('commonError.lastNameInvalid'),
  emailRequired: t('commonError.emailRequired'),
  phoneRequired: t('commonError.phoneRequired'),
  addressRequired: t('commonError.addressRequired'),
  cityRequired: t('commonError.cityRequired'),
  postalRequired: t('commonError.postalRequired'),
  unitRequired: t('commonError.unitRequired'),
  grossMonthRequired: t('commonError.grossMonthRequired'),
  timeAtJobRequired: t('commonError.timeAtJobRequired'),
  employerNameRequired: t('commonError.employerNameRequired'),
  jobTitleRequired: t('commonError.jobTitleRequired'),
  residentInformationRequired: t('commonError.residentInformationRequired'),
  paymentRequired: t('commonError.paymentRequired'),
  recidenceRequired: t('commonError.recidenceRequired'),
  termsAndConditionRequired: t('commonError.termsAndConditionRequired'),
  invalidEmailFormat: t('commonError.invalidEmailFormat'),
  dobRequired: t('commonError.dobRequired'),
  radioError: t('commonError.radioError'),
  vehicleMileageRequired: t('commonError.vehicleMileageRequired'),
  invalidPhoneFormat: t('commonError.invalidPhoneFormat'),
  codeRequired: t('commonError.codeRequired'),
  incomesourceRequired: t('commonError.incomesourceRequired'),
  monthlyIncomeRequired: t('commonError.monthlyIncomeRequired'),
  yearsRequired: t('commonError.yearsRequired'),
  monthsRequired: t('commonError.monthsRequired'),
  companyNameRequired: t('commonError.companyNameRequired'),
  livedMonthsRequired: t('commonError.livedMonthsRequired'),
  monthlyPaymentRequired: t('commonError.monthlyPaymentRequired'),
  secondIncomeRequired: t('commonError.secondIncomeRequired'),
  cityOrTownRequired: t('commonError.cityOrTownRequired'),
  provinceRequired: t('commonError.provinceRequired'),
  postalCodeRequired: t('commonError.postalCodeRequired'),
  ageValidation: t('commonError.ageValidation'),
  verificationCodeRequired: t('commonError.verificationCodeRequired'),
  wrongVerificationCode: t('commonError.wrongVerificationCode'),
  required: t('commonError.required'),
});

export const VEHICLE_SEARCH = 'vehicleSearch';
export const TRADEIN_MODAL_CLOSE = 'trade-in-modal-close';
export const TRADEIN_MODAL_OPEN = 'trade-in-modal-open';
export const TRADEIN_MODAL_OPEN_BTN = 'trade-in-modal-open-btn';

export const CREDIT_SCORE_V2_MODAL_CLOSE = 'credit-score-modal-close';
export const CREDIT_SCORE_V2_MODAL_OPEN = 'credit-score-modal-open';
export const CREDIT_SCORE_V2_MODAL_OPEN_BTN = 'credit-score-modal-open-btn';

export const LEAD_GEN_MODAL_CLOSE = 'lead-gen-modal-close';
export const LEAD_GEN_MODAL_OPEN = 'lead-gen-modal-open';
export const LEAD_GEN_MODAL_OPEN_BTN = 'lead-gen-modal-open-btn';

export const CREDIT_MODAL_CLOSE = 'creditModalClose';

export const COUNTRIES_FOR_PHONE_NUMBER = ['ca', 'us'];

export const LOCAL_STORAGE_KEYS = {
  dynamicStepperFormData: 'dynamicStepperFormData',
  dynamicStepperCurrentStep: 'dynamicStepperCurrentStep',
  draftLeadId: 'draftLeadId',
};

export const CHECK_AVAILABILITY_MODAL_CLOSE = 'check-availability-modal-close';
export const CHECK_AVAILABILITY_MODAL_OPEN = 'check-availability-modal-open';
export const CHECK_AVAILABILITY_MODAL_OPEN_BTN = 'check-availability-modal-open-btn';

export const DIGITAL_RETAILING_MODAL_CLOSE = 'digital-retailing-modal-close';
export const DIGITAL_RETAILING_MODAL_OPEN = 'digital-retailing-modal-open';
export const DIGITAL_RETAILING_MODAL_OPEN_BTN = 'digital-retailing-modal-open-btn';

export const MULTI_CTA_MODAL_OPEN = 'multi-cta-modal-open';
export const MULTI_CTA_MODAL_CLOSE = 'multi-cta-modal-close';
export const MULTI_CTA_MODAL_OPEN_BTN = 'multi-cta-modal-open-btn';

export const COUNTRY_WITH_PROVINCES = [
  {
    label: 'Canada',
    value: 'CA',
    provinces: [
      { label: 'Alberta', value: 'AB' },
      { label: 'British Columbia', value: 'BC' },
      { label: 'Manitoba', value: 'MB' },
      { label: 'New Brunswick', value: 'NB' },
      { label: 'Newfoundland and Labrador', value: 'NL' },
      { label: 'Northwest Territories', value: 'NT' },
      { label: 'Nova Scotia', value: 'NS' },
      { label: 'Nunavut', value: 'NU' },
      { label: 'Ontario', value: 'ON' },
      { label: 'Prince Edward Island', value: 'PE' },
      { label: 'Quebec', value: 'QC' },
      { label: 'Saskatchewan', value: 'SK' },
      { label: 'Yukon', value: 'YT' },
    ],
  },
  {
    label: 'United States',
    value: 'US',
    provinces: [
      { label: 'Alabama', value: 'AL' },
      { label: 'Alaska', value: 'AK' },
      { label: 'Arizona', value: 'AZ' },
      { label: 'Arkansas', value: 'AR' },
      { label: 'California', value: 'CA' },
      { label: 'Colorado', value: 'CO' },
      { label: 'Connecticut', value: 'CT' },
      { label: 'Delaware', value: 'DE' },
      { label: 'District of Columbia', value: 'DC' },
      { label: 'Florida', value: 'FL' },
      { label: 'Georgia', value: 'GA' },
      { label: 'Hawaii', value: 'HI' },
      { label: 'Idaho', value: 'ID' },
      { label: 'Illinois', value: 'IL' },
      { label: 'Indiana', value: 'IN' },
      { label: 'Iowa', value: 'IA' },
      { label: 'Kansas', value: 'KS' },
      { label: 'Kentucky', value: 'KY' },
      { label: 'Louisiana', value: 'LA' },
      { label: 'Maine', value: 'ME' },
      { label: 'Maryland', value: 'MD' },
      { label: 'Massachusetts', value: 'MA' },
      { label: 'Michigan', value: 'MI' },
      { label: 'Minnesota', value: 'MN' },
      { label: 'Mississippi', value: 'MS' },
      { label: 'Missouri', value: 'MO' },
      { label: 'Montana', value: 'MT' },
      { label: 'Nebraska', value: 'NE' },
      { label: 'Nevada', value: 'NV' },
      { label: 'New Hampshire', value: 'NH' },
      { label: 'New Jersey', value: 'NJ' },
      { label: 'New Mexico', value: 'NM' },
      { label: 'New York', value: 'NY' },
      { label: 'North Carolina', value: 'NC' },
      { label: 'North Dakota', value: 'ND' },
      { label: 'Ohio', value: 'OH' },
      { label: 'Oklahoma', value: 'OK' },
      { label: 'Oregon', value: 'OR' },
      { label: 'Pennsylvania', value: 'PA' },
      { label: 'Rhode Island', value: 'RI' },
      { label: 'South Carolina', value: 'SC' },
      { label: 'South Dakota', value: 'SD' },
      { label: 'Tennessee', value: 'TN' },
      { label: 'Texas', value: 'TX' },
      { label: 'Utah', value: 'UT' },
      { label: 'Vermont', value: 'VT' },
      { label: 'Virginia', value: 'VA' },
      { label: 'Washington', value: 'WA' },
      { label: 'West Virginia', value: 'WV' },
      { label: 'Wisconsin', value: 'WI' },
      { label: 'Wyoming', value: 'WY' },
    ],
  },
];
